import { PagedResponse } from ".";

// some api services, e.g. search, that were written during the initial Complaints project
//  will have a slightly different response shape to the newer services
export interface LegacyPagedResponse<T> {
  data: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  extendedProperties?: { [key: string]: string };
}

export type UnknownPagedResponse<T> = LegacyPagedResponse<T> | PagedResponse<T>;

const isLegacyPagedResponse = (item: any) => {
  return (
    item.totalCount !== undefined &&
    item.page !== undefined &&
    item.pageSize !== undefined &&
    item.totalPages !== undefined &&
    Array.isArray(item.data)
  );
};

export const toPagedResponse = <T>(
  response: UnknownPagedResponse<T>
): PagedResponse<T> => {
  if (isLegacyPagedResponse(response)) {
    const {
      data,
      totalCount,
      page,
      pageSize,
    } = response as LegacyPagedResponse<T>;

    return {
      data,
      count: totalCount,
      page,
      pageSize,
    };
  } else {
    return response as PagedResponse<T>;
  }
};
